"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAvailableDataTypesMock = exports.useTsdbDataTypes = void 0;
const data_types_1 = require("@yanzi/data-types");
const react_cirrus_1 = require("@yanzi/react-cirrus");
const react_1 = require("react");
const react_query_1 = require("react-query");
const insight_1 = require("../insight");
const InsightsProvider_1 = require("../insight/InsightsProvider");
const tsdbDataTypes = data_types_1.dataTypes.filter(data_types_1.isTsdbDataType);
function useTsdbDataTypes({ locationId }) {
    const { rateLimitQueue, developerQueries, backendUrl } = InsightsProvider_1.useInsightContext();
    const { socket } = react_cirrus_1.useCirrus();
    const { data } = react_query_1.useQuery([
        'tsdb-temp-start',
        locationId,
        tsdbDataTypes.map(x => x.id),
        developerQueries,
        rateLimitQueue.id,
    ], () => {
        return Promise.all(tsdbDataTypes.map(({ dbTable: table, id }) => __awaiter(this, void 0, void 0, function* () {
            return {
                id,
                result: yield insight_1.queryInsights(LATEST_DATA, {
                    variables: { table },
                    context: { locationId, mode: developerQueries ? 'DEVELOPMENT' : 'PRODUCTION' },
                }, { rateLimitQueue, socket, backendUrl }),
            };
        })));
    }, { staleTime: 1000 * 60 * 10, cacheTime: 1000 * 60 * 5 });
    const latestTimestamps = react_1.useMemo(() => {
        var _a;
        return ((_a = data === null || data === void 0 ? void 0 : data.reduce((agg, val) => { var _a, _b, _c; return (Object.assign(Object.assign({}, agg), { [val.id]: (_c = (_b = (_a = val.result.values) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : null })); }, {})) !== null && _a !== void 0 ? _a : null);
    }, [data]);
    return react_1.useMemo(() => {
        return tsdbDataTypes.filter(dataType => { var _a; return !latestTimestamps ? true : ((_a = latestTimestamps === null || latestTimestamps === void 0 ? void 0 : latestTimestamps[dataType.id]) !== null && _a !== void 0 ? _a : null) !== null; });
    }, [latestTimestamps]);
}
exports.useTsdbDataTypes = useTsdbDataTypes;
function createAvailableDataTypesMock(mockTypes, locationId) {
    return [
        ...mockTypes.map(type => insight_1.mockInsightsQuery({
            query: LATEST_DATA,
            variables: {
                table: type.dbTable,
            },
            context: { locationId },
        }, [[1]])),
        ...data_types_1.dataTypes
            .filter(data_types_1.isTsdbDataType)
            .filter(x => !mockTypes.some(({ id }) => id === x.id))
            .map(type => insight_1.mockInsightsQuery({
            query: LATEST_DATA,
            variables: { table: type.dbTable },
            context: { locationId },
        }, [])),
    ];
}
exports.createAvailableDataTypesMock = createAvailableDataTypesMock;
const LATEST_DATA = insight_1.sql `
  SELECT time, did FROM ${['table', 'variableName']} ORDER BY time DESC LIMIT 1;
`;
//# sourceMappingURL=useTsdbDataTypes.js.map